import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, FileSpreadsheet, FileText, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ANALYTICS_TOOLBAR_BUTTON_COMPACT_CLASS } from "../shared/toolbarButtonStyles";

type ExportFormat = "csv" | "xlsx";

interface OperationsExecutionExportMenuProps {
  onExportProcessingTime: (format: ExportFormat) => void;
  onExportOnTimeRate: (format: ExportFormat) => void;
  disabled?: boolean;
}

export const OperationsExecutionExportMenu: React.FC<
  OperationsExecutionExportMenuProps
> = ({ onExportProcessingTime, onExportOnTimeRate, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          type="button"
          variant="span"
          className={ANALYTICS_TOOLBAR_BUTTON_COMPACT_CLASS}
        >
          <Share className="size-3.5 shrink-0" />
          {t("analytics.export.label", "Export")}
          <ChevronDown className="size-3.5 shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[220px]">
        <DropdownMenuLabel>
          {t(
            "analytics.operations.export.processingTimeGroup",
            "Processing time",
          )}
        </DropdownMenuLabel>
        <DropdownMenuItem onClick={() => onExportProcessingTime("xlsx")}>
          <FileSpreadsheet className="size-4" />
          {t("analytics.common.xlsx", "XLSX")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onExportProcessingTime("csv")}>
          <FileText className="size-4" />
          {t("analytics.common.csv", "CSV")}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>
          {t("analytics.operations.export.onTimeRateGroup", "On-time rate")}
        </DropdownMenuLabel>
        <DropdownMenuItem onClick={() => onExportOnTimeRate("xlsx")}>
          <FileSpreadsheet className="size-4" />
          {t("analytics.common.xlsx", "XLSX")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onExportOnTimeRate("csv")}>
          <FileText className="size-4" />
          {t("analytics.common.csv", "CSV")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
